<header class="panel-header">
  <h1>Business Continuity &amp; Impact Analysis</h1>
  <p>Ingest existing resilience frameworks. Upload simulated documents only.</p>
</header>

<div class="warning-banner" role="alert">
  <span class="warning-icon">!</span>
  <span
    >Privacy Warning: Do not upload real, confidential documents. Use simulated
    or sanitized versions only.</span
  >
</div>

<section class="step-two-sections">
  <article class="document-section" *ngFor="let section of uploadSections">
    <div
      class="document-dropzone"
      [class.drag-over]="stepTwoDragOverCategory === section.key"
      (dragover)="onStepTwoDragOver($event, section.key)"
      (dragleave)="onStepTwoDragLeave($event)"
      (drop)="onStepTwoDrop($event, section.key)"
    >
      <div class="document-copy">
        <h2>{{ section.title }}</h2>
        <p>{{ section.description }}</p>
        <span>{{ section.hint }}</span>
      </div>

      <input
        #stepTwoInput
        type="file"
        class="upload-input"
        multiple
        accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt"
        (change)="onStepTwoFileSelected($event, section.key)"
      />

      <button
        type="button"
        class="upload-button upload-button-step-two"
        (click)="stepTwoInput.click()"
      >
        <img
          src="assets/icons/upload_icon.svg"
          alt="Upload"
          class="upload-button-icon"
        />
        <span>Select File</span>
      </button>
    </div>

    <div class="file-group" *ngIf="uploadedFiles[section.key].length > 0">
      <h3>{{ section.filesLabel }}</h3>

      <div class="file-list">
        <div class="file-card" *ngFor="let file of uploadedFiles[section.key]">
          <div class="file-meta">
            <span class="file-icon">📄</span>
            <div class="file-copy">
              <strong>{{ file.name }}</strong>
              <span>{{ file.sizeLabel }}&nbsp;&nbsp;Completed</span>
            </div>
          </div>

          <button
            type="button"
            class="file-delete"
            aria-label="Remove file"
            (click)="removeUploadedFile(section.key, file.id)"
          >
            <img src="assets/icons/trash_icon.svg" alt="Delete" />
          </button>
        </div>
      </div>
    </div>
  </article>
</section>

<div class="info-banner">
  <span class="info-icon">i</span>
  <span
    >If you skip BCP/BIA upload, the ai will design a generic scenario
    appropriate for your industry.</span
  >
</div>
